export const OPTHINES = {
  voteName: '2019poject/2019technology',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: true,
  themeColor: {
    activeBgColor: '#f5d57b',
    inactiveBgColor: '#313e76',
  },
  tabs: [
    {
      tabName: '我要点赞',
      tabPath: '/2019KJHLW/first',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019KJHLW/second',
    },
    {
      tabName: '评选说明',
      tabPath: '/2019KJHLW/third',
    },
  ],
};
